import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { RequestInterceptor } from './utils/request-interceptor';
import { BaseService } from './services/base.service';
import { StaticStoreService } from './services/static-store.service';

import { LOCALE_ID } from '@angular/core';

import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StaticStoreEffects } from './stateManagement/effects/static-store.effect';
import { ToastEffects } from './stateManagement/effects/toast.effect';
import { staticStoreReducer } from './stateManagement/reducers/static-store.reducer';
import { toastReducer } from './stateManagement/reducers/toast.reducer';
import { EnviarEmailContatoEffects } from './stateManagement/effects/enviar-email-contato.effect';
import { EnviarEmailContatoReducer } from './stateManagement/reducers/enviar-email-contato.reducer';
import { EmailService } from './services/email.service';
import { ObterDadosContatosReducer } from './stateManagement/reducers/obter-dados-contatos.reducer';
import { ObterDadosContatosEffects } from './stateManagement/effects/obter-dados-contatos.effect';
import { DadosContatosService } from './services/dados-contatos.service';
import { AutenticacaoService } from './services/autenticacao.service';
import { ListarPerguntasFrequentesReducer } from './stateManagement/reducers/perguntas-frequentes.reducer';
import { ListarPerguntasFrequentesEffects } from './stateManagement/effects/perguntas-frequentes.effect';
import { PerguntasFrequentesService } from './services/perguntas-frequentes.service';
import { ComunicadosService } from './services/comunicados.service';
import { ListarComunicadosReducer } from './stateManagement/reducers/listar-comunicados.reducer';
import { ListarComunicadosEffects } from './stateManagement/effects/listar-comunicados.effect';
import { ObterUltimaEdicaoECalendarioReducer } from './stateManagement/reducers/Jornal/obter-ultima-edicao-e-calendario-para-home.reducer';
import { ObterUltimaEdicaoECalendarioEffects } from './stateManagement/effects/Jornal/obter-ultima-edicao-e-calendario-para-home.effect';
import { JornalService } from './services/jornal.service';
import { listarEdicoesCalendarioReducer } from './stateManagement/reducers/Jornal/listar-edicoes-para-calendario.reducer';
import { ListarEdicoesCalendarioEffects } from './stateManagement/effects/Jornal/listar-edicoes-para-calendario.effect';
import { ObterEdicaoPorDataEffects } from './stateManagement/effects/Jornal/obter-edicao-por-data-publicacao.effect';
import { ObterEdicaoPorDataReducer } from './stateManagement/reducers/Jornal/obter-edicao-por-data-publicacao.reducer';
import { ObterEdicaoPorIdReducer } from './stateManagement/reducers/Jornal/obter-edicao-por-id.reducer';
import { ObterEdicaoPorIdEffects } from './stateManagement/effects/Jornal/obter-edicao-por-id.effect';
import { ObterArquivoCadernoPorIdReducer } from './stateManagement/reducers/Caderno/obter-arquivo-caderno-por-id.reducer';
import { ObterArquivoCadernoPorIdEffects } from './stateManagement/effects/Caderno/obter-arquivo-caderno-por-id.effect';
import { GlossarioService } from './services/glosssario.service';
import { ObterGlossarioReducer } from './stateManagement/reducers/obter-glossario.reducer';
import { ObterGlossarioEffects } from './stateManagement/effects/glossario.effect';
import { ServicoJornalService } from './services/servico-jornal.service';
import { ListarServicosReducer } from './stateManagement/reducers/Servicos/servicos-jornal.reducer';
import { ListarServicosEffects } from './stateManagement/effects/Servicos/servicos-jornal.effect';
import { ObterArquivoServicoEffects } from './stateManagement/effects/Servicos/obter-arquivo-servico-jornal.effect';
import { ObterArquivoServicoReducer } from './stateManagement/reducers/Servicos/obter-arquivo-servico-jornal.reducer';
import { ObterCalendariosPublicacoesReducer } from './stateManagement/reducers/obter-calendarios-publicacoes.reducer';
import { CalendarioService } from './services/calendario.service';
import { ObterCalendariosPublicacoesEffects } from './stateManagement/effects/obter-calendarios-publicacoes.effect';
import { ObterPaginaJornalPorAutenticidadeReducer } from './stateManagement/reducers/Autenticidade/obter-pagina-jornal-por-autenticidade.reducer';
import { ObterPaginaJornalPorAutenticidadeEffects } from './stateManagement/effects/Autenticidade/obter-pagina-jornal-por-autenticidade.effect';
import { PesquisarJornalPaginadoEffects } from './stateManagement/effects/Pesquisa/pesquisar-jornal-paginado.effect';
import { PesquisarJornalPaginadoReducer } from './stateManagement/reducers/Pesquisa/pesquisar-jornal-paginado.reducer';
import { SobreService } from './services/sobre.service';
import { BancoNoticiasService } from './services/banco-noticias.service';
import { ObterBancoNoticiasReducer } from './stateManagement/reducers/BancoNoticias/obter-banco-noticias.reducer';
import { ObterBancoNoticiasEffects } from './stateManagement/effects/BancoNoticias/obter-banco-noticias.effect';
import { AutenticidadeService } from './services/autenticidade.service';
import { PesquisaService } from './services/pesquisa.service';
import { CadernoService } from './services/caderno.service';
import { ObterUltimaEdicaoReducer } from './stateManagement/reducers/Jornal/obter-utlima-edicao.reducer';
import { ObterUltimaEdicaoEffects } from './stateManagement/effects/Jornal/obter-ultima-edicao.effect';
import { ObterArquivoPdfNoticiaEffects } from './stateManagement/effects/BancoNoticias/obter-arquivo-pdf-noticia.effect';
import { ObterArquivoPdfNoticiaReducer } from './stateManagement/reducers/BancoNoticias/obter-arquivo-pdf-noticia.reducer';
import { provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import { ObterSobreEffects } from './stateManagement/effects/Sobre/obter-sobre.effect';
import { ObterArquivoPoliticaPrivacidadeEffects } from './stateManagement/effects/Sobre/obter-politica-privacidade.effect';
import { ObterSobreReducer } from './stateManagement/reducers/Sobre/obter-sobre.reducer';
import { ObterArquivoPoliticaPrivacidadeReducer } from './stateManagement/reducers/Sobre/obter-politica-privacidade.reducer';
import { GoogleAnalyticsService } from './services/analytics/google-analytics.service';
import { ObterConteudoCadernoPorIdReducer } from './stateManagement/reducers/Caderno/obter-conteudo-caderno-por-id.reducer';
import { ObterConteudoCadernoPorIdEffects } from './stateManagement/effects/Caderno/obter-conteudo-caderno-por-id.effect';
import { EdicaoPublicadaService } from './services/edicao-publicada.service';
import { ObterUltimaEdicaoPublicadaEffects, obterUltimaEdicaoPublicadaReducer } from './stateManagement/full-states/publicacao/obter-ultima-edicao-publicada.state';
import { ObterEdicoesPublicadasPorDataEffects, obterEdicoesPublicadasPorDataReducer } from './stateManagement/full-states/publicacao/obter-edicoes-publicadas-por-data.state';
import { ObterCalendarioEdicoesPublicadasEffects, obterCalendarioEdicoesPublicadasReducer } from './stateManagement/full-states/publicacao/obter-calendario-edicoes-publicadas.state';
import { ListarMateriasPublicadasHtmlEffects, listarMateriasPublicadasHtmlReducer } from './stateManagement/full-states/publicacao/listar-materias-publicadas-html.state';
import { BaixarPdfEdicaoEffects, baixarPdfEdicaoReducer } from './stateManagement/full-states/publicacao/baixar-pdf-caderno-edicao.state';
import { BaixarPdfMateriaPublicadaEffects, baixarPdfMateriaPublicadaReducer } from './stateManagement/full-states/publicacao/baixar-pdf-materia-publicada.state';
import { ObterSumarioPublicacaoHtmlEffects, obterSumarioPublicacaoHtmlReducer } from './stateManagement/full-states/publicacao/obter-sumario-publicacao-html.state';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    BaseService,
    AutenticacaoService,
    AutenticidadeService,
    BancoNoticiasService,
    CadernoService,
    CalendarioService,
    ComunicadosService,
    DadosContatosService,
    EmailService,
    GlossarioService,
    JornalService,
    EdicaoPublicadaService,
    PerguntasFrequentesService,
    PesquisaService,
    ServicoJornalService,
    SobreService,
    StaticStoreService,
    GoogleAnalyticsService,
    provideAnimations(),
    provideToastr(
      {
        timeOut: 15000,
        closeButton: true,
        progressBar: true
      }
    ),
    provideNgxMask(),
    provideEnvironmentNgxMask({
      validation: false
    }),
    provideStore({
      toast: toastReducer,
      staticStore: staticStoreReducer,
      enviarContato: EnviarEmailContatoReducer,
      obterArquivoCadernoPorId: ObterArquivoCadernoPorIdReducer,
      obterConteudoCadernoPorId: ObterConteudoCadernoPorIdReducer,
      obterArquivoServico: ObterArquivoServicoReducer,
      obterCalendariosPublicacoes: ObterCalendariosPublicacoesReducer,
      obterDadosContatos: ObterDadosContatosReducer,
      obterEdicaoPorData: ObterEdicaoPorDataReducer,
      obterEdicaoPorId: ObterEdicaoPorIdReducer,
      obterPaginaJornalPorAutenticidade: ObterPaginaJornalPorAutenticidadeReducer,
      obterUltimaEdicaoECalendario: ObterUltimaEdicaoECalendarioReducer,
      obterGlossario: ObterGlossarioReducer,
      listarComunicados: ListarComunicadosReducer,
      listarEdicoesCalendario: listarEdicoesCalendarioReducer,
      listarServicos: ListarServicosReducer,
      listarPerguntasFrequentes: ListarPerguntasFrequentesReducer,
      pesquisarJornalPaginado: PesquisarJornalPaginadoReducer,
      obterSobre: ObterSobreReducer,
      obterBancosNoticias: ObterBancoNoticiasReducer,
      obterArquivoPdfNoticia: ObterArquivoPdfNoticiaReducer,
      obterUltimaEdicao: ObterUltimaEdicaoReducer, 
      obterArquivoPoliticaPrivacidade: ObterArquivoPoliticaPrivacidadeReducer,
      obterUltimaEdicaoPublicada: obterUltimaEdicaoPublicadaReducer,
      obterEdicoesPublicadasPorData: obterEdicoesPublicadasPorDataReducer,
      obterCalendarioEdicoesPublicadas: obterCalendarioEdicoesPublicadasReducer,
      listarMateriasPublicadasHtml: listarMateriasPublicadasHtmlReducer,
      baixarPdfEdicao: baixarPdfEdicaoReducer,
      baixarPdfMateriaPublicada: baixarPdfMateriaPublicadaReducer,
      obterSumarioPublicacaoHtml: obterSumarioPublicacaoHtmlReducer
    }),
    provideEffects([
      ToastEffects,
      StaticStoreEffects,
      EnviarEmailContatoEffects,
      ObterArquivoCadernoPorIdEffects,
      ObterConteudoCadernoPorIdEffects,
      ObterArquivoServicoEffects,
      ObterArquivoPdfNoticiaEffects,
      ObterBancoNoticiasEffects,
      ObterCalendariosPublicacoesEffects,
      ObterDadosContatosEffects,
      ObterEdicaoPorDataEffects,
      ObterEdicaoPorIdEffects,
      ObterPaginaJornalPorAutenticidadeEffects,
      ObterUltimaEdicaoECalendarioEffects,
      ObterUltimaEdicaoEffects,
      ObterGlossarioEffects,
      ListarComunicadosEffects,
      ListarPerguntasFrequentesEffects,
      ListarEdicoesCalendarioEffects,
      ListarServicosEffects,
      PesquisarJornalPaginadoEffects,
      ObterSobreEffects, 
      ObterArquivoPoliticaPrivacidadeEffects,
      ObterUltimaEdicaoPublicadaEffects,
      ObterEdicoesPublicadasPorDataEffects,
      ObterCalendarioEdicoesPublicadasEffects,
      ListarMateriasPublicadasHtmlEffects,
      BaixarPdfEdicaoEffects,
      BaixarPdfMateriaPublicadaEffects,
      ObterSumarioPublicacaoHtmlEffects
    ]),
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ]
};
